import React from 'react';
import OnboardingNav from '../OnboardingNav';
import './AuthenticatedLayout.css';

const AuthenticatedLayout = ({ children }) => {
  return (
    <div className="authenticated-layout">
      <OnboardingNav />

      <div className="authenticated-content">
        {children}
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
